/**
 * add aria-hidden to all hidden form fields
 */
const setupCommunityForms = () =>
{
	const hiddenFields = document.querySelectorAll( '.wpforms-field.d-none' );

	hiddenFields.forEach( field => field.setAttribute( 'aria-hidden', 'true' ) );
};


/**
 *
 */
export default setupCommunityForms;